import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Money from "../core/Money";
import useBasket from "../../utils/useBasket";
import {Link} from "react-router-dom";

export default function SliderItem({product}: { product: ProductInterface }) {
    const {addToBasket, } = useBasket(product);

    return (<div className="d-flex basket__slide prod-card">
        <div className="basket__slide-img p-3">
            <picture>
                <img style={{maxHeight: '70px'}} src={'https://www.pride.ru' + (product.list_image || '/images/no-photo.jpg')}
                     className="w-auto d-block h-auto m-auto" alt={product.name}/>
            </picture>
        </div>
        <div className="basket__slide-body">
            <div className="prod-card__text prod-card__title t-elips-3">
                <Link to={`/catalog/item/${product.catalog_code}/${product.id}/${product.human_url}`}>{product.name}</Link>
            </div>
            <div className="d-flex align-items-center basket__slide-bot">
                <div className="d-flex align-items-center flex-wrap m-0 price-row">
                    {product.base_price.amount > product.current_price.amount &&
                        <p className="prod-card__text fw-medium t-gray text-decoration-line-through"><Money
                            value={product.base_price}/></p>}
                    <p className="prod-card__text fw-bold big t-orange">
                        <Money value={product.current_price}/>
                    </p>
                </div>
                <button
                    onClick={() => {
                        addToBasket()
                    }}

                    className={"d-flex align-items-center justify-content-center big btn btn-primary prod-card__btn"}>
                    <div className="btn__img">
                        <img src="/images/icon-shop.svg" alt=""/>
                    </div>
                    <span>Добавить</span>
                </button>
            </div>

        </div>
    </div>)
}